import React, { useContext, useEffect } from "react";
import { Title } from "../../../../../../stories/Title/Title";
import Close from "../../../../../../images/Close.svg";
import { Label } from "../../../../../../stories/Label/Label";
import timer from "../../../../../../images/VendorReply.svg";
import { useLazyQuery } from "@apollo/client";
import { AtsStckItemDetails } from "../../../masters/items/queries/types";
import { GetItemDetatilsByNodeId } from "../queries";
import { AppContext } from "../../../../../../context/context";
import { nodeVar } from "../../../../../../utils/commonQueryTypes";
import useLabels from "../../../../../../customHooks/useLabels";
import { toStandardDate } from "../../../../../../utils/UtilFunctions";
import { DEFAULT_TIME } from "../../../../../../utils/constants";

interface Props {
  setAssetDetails: React.Dispatch<React.SetStateAction<boolean>>;
}

const AssetDetails = ({ setAssetDetails }: Props) => {
  const { state } = useContext(AppContext);
  const { companyLabel, subsidiaryLabel, subsidiarySiteLabel, junctionLabel, itemLabel } =
    useLabels();

  const [getItemDetatilsByNodeId, { data: itemDetails }] = useLazyQuery<
    { node: AtsStckItemDetails },
    nodeVar
  >(GetItemDetatilsByNodeId);

  useEffect(() => {
    if (state.itemDetailsId) {
      getItemDetatilsByNodeId({
        variables: {
          id: Number(state.itemDetailsId),
        },
      });
    }
  }, [getItemDetatilsByNodeId, state.itemDetailsId]);

  const asset_details = [
    {
      data: "Description",
      value: itemDetails?.node.item.desc,
    },
    {
      data: "Code",
      value: itemDetails?.node.item.code,
    },
    {
      data: "GST Applicable",
      value: itemDetails?.node.item.enableGst ? "Applicable" : "Not Applicable",
    },
    {
      data: "Category",
      value: itemDetails?.node.item.categoryDetails.categoryName,
    },
    {
      data: "Sub - Cataegory",
      value: itemDetails?.node.item.subCategoryDetails.subCategoryName,
    },
    {
      data: "Maintained By",
      value: itemDetails?.node.vendorDetails.desc,
    },
    {
      data: "UOM",
      value: itemDetails?.node.item.uomDetails.uomDesc,
    },
    {
      data: "Model",
      value: itemDetails?.node.item.prodModel,
    },
  ];
  const product_info = [
    {
      data: "Serial No",
      value: itemDetails?.node.prodSerialNo,
    },
    {
      data: "Batch",
      value: itemDetails?.node.prodBatchNo,
    },
    {
      data: "Expiry",
      value: itemDetails?.node.prodExpiryDate
        ? toStandardDate(itemDetails?.node.prodExpiryDate) ===
          toStandardDate(DEFAULT_TIME)
          ? "-"
          : toStandardDate(itemDetails?.node.prodExpiryDate)
        : "-",
    },
    {
      data: "Warranty Start Date",
      value: itemDetails?.node.prodWarrantyStartDate
        ? toStandardDate(itemDetails?.node.prodWarrantyStartDate) ===
          toStandardDate(DEFAULT_TIME)
          ? "-"
          : toStandardDate(itemDetails?.node.prodWarrantyStartDate)
        : "-",
    },
    {
      data: "Warranty End Date",
      value: itemDetails?.node.prodWarrantyEndDate
        ? toStandardDate(itemDetails?.node.prodWarrantyEndDate) ===
          toStandardDate(DEFAULT_TIME)
          ? "-"
          : toStandardDate(itemDetails?.node.prodWarrantyEndDate)
        : "-",
    },
    {
      data: "Maintained By",
      value: itemDetails?.node.vendorDetails.desc,
    },
    {
      data: "Geo Location",
      value: `${itemDetails?.node.prodLatitude}, ${itemDetails?.node.prodLongitude}`,
    },
    {
      data: "Asset Location",
      value: "",
    },
    {
      data: "Installation Date & Time",
      value: itemDetails?.node.prodInstallationEndDate
        ? toStandardDate(itemDetails?.node.prodInstallationEndDate) ===
          toStandardDate(DEFAULT_TIME)
          ? "-"
          : toStandardDate(itemDetails?.node.prodInstallationEndDate)
        : "-",
    },
  ];

  const allocation_details = [
    {
      data: `${companyLabel}`,
      value: itemDetails?.node.currentCompany?.name,
    },
    {
      data: `${subsidiaryLabel}`,
      value: itemDetails?.node.currentSubsidiary?.name,
    },
    {
      data: `${subsidiarySiteLabel}`,
      value: itemDetails?.node.currentSite?.name,
    },
    {
      data: `${junctionLabel}`,
      value: itemDetails?.node.currentJunction?.name,
    },
  ];

  return (
    <>
      <div className="particular-asset__details">
        <div className="particular-asset__details--title">
          <Title>Details</Title>
          <img src={Close} alt="" onClick={() => setAssetDetails(false)} />
        </div>
        <div className="particular-asset__details--block">
          <b className="d-main-page__block--title">{itemLabel} Details</b>
          <div className="particular-asset__details--block--grid">
            {asset_details.map((item, index) => (
              <React.Fragment key={index}>
                <Label>{item.data}</Label>
                <span>:</span>
                <span>{item.value}</span>
              </React.Fragment>
            ))}
          </div>
          <b className="d-main-page__block--title">Ticket Details</b>
          <div className="particular-asset__details--block--ticket">
            <b>No Tickets</b> <br />
            <button className="particular-asset__details--block--ticket--view">
              View Details&nbsp;
              <img src={timer} alt="/" />
            </button>
          </div>
          <b className="d-main-page__block--title">Product Information</b>
          <div className="particular-asset__details--block--grid">
            {product_info.map((item, index) => (
              <React.Fragment key={index}>
                <Label>{item.data}</Label>
                <span>:</span>
                <span>{item.value}</span>
              </React.Fragment>
            ))}
          </div>
          <b className="d-main-page__block--title">Allocation Details</b>
          <div className="particular-asset__details--block--grid">
            {allocation_details.map((item, index) => (
              <React.Fragment key={index}>
                <Label>{item.data}</Label>
                <span>:</span>
                <span>{item.value}</span>
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default AssetDetails;
